// extracted by mini-css-extract-plugin
export default {"steps":"index_steps__Doo6A"};